import {computed, inject, Pipe, PipeTransform, Signal} from '@angular/core';
import {Lottery, isUserEligibleForApartment} from "../model/lottery";
import {UserService} from "../services/user.service";

@Pipe({
  name: 'estimatedEligibility'
})
export class EstimatedEligibilityPipe implements PipeTransform {
  private readonly user = inject(UserService).user;

  transform(apartment: Lottery): Signal<boolean> {
    return computed(() => {
      const user = this.user();

      if (!user) {
        return false;
      }

      return isUserEligibleForApartment(apartment, user);
    });
  }

}
